const registerServiceWorker = () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("./firebase-messaging-sw.js")
      .then(function (registration) {
        console.log("Registration successful, scope is:", registration.scope);

        registration.update();

        setInterval(() => {
          registration.update();
        }, 60000);
      })
      .catch(function (err) {
        console.log("Service worker registration failed, error:", err);
      });

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      window.location.reload();
    });
  }
};

export { registerServiceWorker };
